import React from "react"
import {Modal,Button} from "react-bootstrap"
import {FaTrash} from "react-icons/fa"

const DeleteAgentModal=({show,handleClose,confirmDelete})=>{

return(

<Modal show={show} onHide={handleClose} centered>

<Modal.Body className="text-center p-4">

<div style={{fontSize:"45px",color:"red"}}>
<FaTrash/>
</div>

<h4 className="mt-3">Confirm Delete</h4>

<p>You want to delete this agent. This cannot be undone.</p>

<div className="d-flex justify-content-center gap-3 mt-3">

<Button variant="light" onClick={handleClose}>
Cancel
</Button>

<Button variant="danger" onClick={confirmDelete}>
Yes, Delete
</Button>

</div>

</Modal.Body>

</Modal>

)

}

export default DeleteAgentModal